import { useRain, useRaindrop } from './use-rain';
import React, { useRef } from 'react';
import { a } from '@react-spring/three';
import { extend } from '@react-three/fiber';
import * as meshline from 'threejs-meshline';
extend(meshline);
export const Raindrop = (props) => {
    const raindrop = useRef();
    const mat = useRef();
    useRaindrop(raindrop, mat, { value: props.value, style: props.style });
    return (React.createElement("mesh", { ref: raindrop },
        React.createElement("meshLine", { attach: "geometry", vertices: props.value.vertices }),
        React.createElement("meshLineMaterial", { attach: "material", ref: mat, transparent: true, depthTest: false, sizeAttenuation: true, lineWidth: 0.01, opacity: 0, color: props.value.color })));
};
const Rain = (props) => {
    const { lines } = useRain(props);
    return (React.createElement(a.group, null, lines.map((raindrop, index) => {
        return React.createElement(Raindrop, { key: index, value: raindrop, style: props.style });
    })));
};
export default Rain;
